<template>
  <AnalyticsWidget
    title="Outbound Performance"
    subTitle="List of recent outbound tasks completed and their orders / operational codes"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">
    <div class="p-2 h-100">
      <LoadingPanel :loading="loading" />
      <Scroller maxHeight="300" height="300">
        <AnalyticsBreakdownTable>
          <template v-slot:header>
            <tr>
              <th>Task</th>
              <th>Name</th>
              <th>Date</th>
              <th>Orders</th>
              <th>Info</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="taskInfo of taskList" :key="taskInfo.id">
              <td><LinkTask :id="taskInfo.id" :name="taskInfo.sequenceNumber" /></td>
              <td>{{ taskInfo.name }}</td>
              <td>{{ formatDate(taskInfo.completedDate) }}</td>
              <td>{{ taskInfo.totalOrderCount }}</td>
              <td><LabelBadge :labelClass="taskInfoClass(taskInfo)">{{ taskInfoDisplay(taskInfo) }}</LabelBadge></td>
            </tr>
          </template>
        </AnalyticsBreakdownTable>
      </Scroller>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'

export default {
  name: 'OrderDIFOTOutboundTaskPerformanceWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable
  },
  props: {
    contactId: Number,
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  data() {
    return {
      loading: false,
      taskList: []
    }
  },
  computed: {
    
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      this.loading = true

      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
        startDate: moment().local().subtract(30, 'days').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString(),
      }

      this.$apiService.analyticsService.getOutboundTaskDIFOTList(params)
      .then(response => {
        this.taskList = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    taskInfoDisplay(task) {
      if(task.totalOrderCount == 0)
        return 'Empty'
      if(task.missOrderCount == 0 && task.excludeOrderCount == 0)
        return 'Clean'
      if(task.excludeOrderCount > 0 && task.missOrderCount == 0)
        return `${task.excludeOrderCount} Late`
      if(task.missOrderCount > 0)
        return `${task.missOrderCount + task.excludeOrderCount} Late`

      return ''
    },
    taskInfoClass(task) {
      if(task.totalOrderCount == 0)
        return 'label-difot-result-hit'
      if(task.missOrderCount == 0 && task.excludeOrderCount == 0)
        return 'label-difot-result-hit'
      if(task.excludeOrderCount > 0 && task.missOrderCount == 0)
        return `label-difot-result-exclude`
      if(task.missOrderCount > 0)
        return `label-difot-result-miss`

      return ''
    }
  }
}
</script>
